<template>
  <div class="jobFairStatus">
    <span v-if="status == 1" class="status_1">报名即将开始</span>
    <span v-if="status == 2" class="status_2">报名进行中</span>
    <span v-if="status == 3" class="status_3">报名结束即将开始</span>
    <span v-if="status == 4" class="status_4">招聘会进行中</span>
    <span v-if="status == 5" class="status_5">已结束</span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      default() {
        return 0
      }
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
@import "@/assets/css/enterprise_color.scss";
.jobFairStatus {
  position: absolute;
  right: -40px;
  top: 8px;
  width: 150px;
  height: 35px;
  span {
    display: block;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #fff;
    transform-origin: 55px center;
    transform: rotate(45deg);
    font-size: 13px;
    &.status_1 {
      background-color: $green_bright;
    }

    &.status_2 {
      background-color: $orange_weight;
    }

    &.status_3 {
      background-color: $label_two;
      font-size: 12px;
    }

    &.status_4 {
      background-color: $label_five;
    }

    &.status_5 {
      background-color: $label_three;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/model/jobFairStatus.vue